<div *ngIf="isVisible" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 transition-opacity"></div>

  <!-- Modal -->
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl">
        <!-- Modal Header -->
        <div class="sm:flex sm:items-start px-4 py-4 lg:px-6 lg:py-4">
          <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
            <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">
              {{ selectedCompany?.name || 'Company Name' }}
            </h3>
            <p class="mt-2 text-sm text-gray-500" [innerHTML]="displayMessage"></p>
            <p class="mt-2 text-sm text-gray-500">Please click "Confirm" to proceed changing the company.</p>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <button
            type="button"
            (click)="confirmSelection()"
            [disabled]="isChanging"
            class="inline-flex w-full justify-center rounded-md bg-[#802cfa] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-90 disabled:opacity-50 disabled:cursor-not-allowed sm:ml-3 sm:w-auto">
            Confirm
          </button>
          <button
            type="button"
            (click)="handleIsVisible(false)"
            class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
